/**
 * Duck-typed `code` check. Errors cross structured-clone boundaries (workers,
 * query caches) and lose their prototypes, so `instanceof` alone is not enough;
 * every typed-error guard pairs it with this.
 */
export function hasErrorCode(error: unknown, ...codes: string[]): boolean {
    return (
        typeof error === 'object' &&
        error !== null &&
        'code' in error &&
        codes.includes((error as { code: unknown }).code as string)
    );
}
